<template>
  <div>
    <div>
      <v-toolbar flat color="white" class="mb-4">
        <v-toolbar-title>{{ $t("route.news") }}</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="createNews">
          {{ $t("button.create") }}
        </v-btn>
      </v-toolbar>
      <global-search-filter :queries="queries" ref="search_filter_ref" />
      <v-col cols="12" md="5">
        <v-select
          :items="tags"
          v-model="tagsValus"
          :label="$t('fields_names.fitler_by_tags')"
          multiple
          chips
          @change="buildTagsFilter"
        ></v-select>
      </v-col>
      <v-col sm="12">
        <v-btn @click="ClearAllFilters" class="error">{{
          $t("button.reset")
        }}</v-btn>
      </v-col>
      <wrapping-table pathName="news" :headersName="headers" ref="table_ref">
        <template slot-scope="{ item, index }">
          <td class="text-sm-center">
            <v-avatar size="40">
              <v-img
                :src="item.main_photo ? item.main_photo.path : ''"
                alt="main_photo"
                class="hover-pointer"
                @click="showImagePreview(item.main_photo)"
                :title="
                  item.main_photo ? $t('labels.preview') : $t('labels.no_photo')
                "
              ></v-img>
            </v-avatar>
          </td>
          <td class="text-sm-center">{{ item.title | truncate(40) }}</td>
          <td class="text-sm-center">{{ item.date && item.date.date }}</td>
          <td class="text-sm-center">
            {{ item.publisher ? item.publisher : $t("labels.no_publisher") }}
          </td>
          <td class="text-sm-center">
            <v-icon small @click="handleEdit(item)">mdi-pencil</v-icon>
            <v-icon small @click="handleDelete(item, index)">mdi-delete</v-icon>
          </td>
        </template>
      </wrapping-table>

      <!-- Image Preview -->
      <global-image-preview
        :showDialog="imageOverlay"
        :imagePath="currentPreviewImage"
        @closePreview="imageOverlay = false"
      />
      <!-- Image Preview -->
    </div>
  </div>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";
export default {
  name: "News",

  data() {
    return {
      news: [],
      headers: ["photo", "title", "date", "publisher", "actions"],
      pagination: {},
      loader: true,
      filterQuery: {},
      imageOverlay: false,
      currentPreviewImage: "",
      queries: {
        query: {
          title: "",
          publisher: "",
        },
      },
      tags: [],
      tagsValus: [],
    };
  },

  created() {
    // window.navigator.geolocation.getCurrentPosition(
    //   position => console.log(position, "position"),
    //   err => console.log(err)
    // );
  },
  methods: {
    buildTagsFilter() {
      let queries = {};
      queries.tags = this.tagsValus.join();
      if (queries["tags"] === "") {
        this.$router.push({ query: {} });
      } else {
        const query = { ...this.$route.query, ...queries };
        this.$router.push({ query });
      }
    },
    async getTags() {
      const res = await IndexData({ reqName: "tags" });
      const { data } = res.data;

      this.tags = data.map((el) => el.name);
    },
    ClearAllFilters() {
      this.$refs.search_filter_ref.ClearFilter();
      // this.$refs.toggle_filter_ref.ClearFilter();
      this.topic = "";
      this.$router.push({ query: {} });
    },
    createNews() {
      this.$router.push("/news/new");
    },
    handleEdit({ slug }) {
      this.$router.push({ path: "/news/new", query: { slug } });
    },
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    },
    showImagePreview(image) {
      if (image) {
        this.currentPreviewImage = image.path;
        this.imageOverlay = true;
      }
    },
  },
  watch: {
    $route: {
      handler({ query }) {
        this.getTags();
        this.tagsValus = query.tags ? query.tags.split(",") : "";
      },
      immediate: true,
    },
  },
};
</script>
